import React, { useState, useRef, useEffect } from "react";
import { FaUser, FaSignOutAlt, FaCog, FaChartBar, FaBox, FaUsers, FaImage, FaGift, FaShoppingBag } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/config";
import "./AdminHeader.css";

const AdminHeader = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem("adminSession");
      localStorage.removeItem("adminEmail");
      navigate("/admin-login");
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  return (
    <header className="admin-header">
      <div className="admin-header-container">
        {/* Logo Section */}
        <Link to="/admin-dashboard" className="admin-logo-section" style={{ textDecoration: 'none' }}>
          <div className="admin-logo-box">
            <span>banat</span>
          </div>
          <span className="admin-panel-title">Admin Panel</span>
        </Link>

        {/* Admin Navigation */}
        <nav className="admin-nav">
          <Link to="/admin-dashboard" className="admin-nav-item">
            <FaChartBar />
            <span>Dashboard</span>
          </Link>
          <Link to="/admin-orders" className="admin-nav-item">
            <FaBox />
            <span>Orders</span>
          </Link>
          <Link to="/admin-users" className="admin-nav-item">
            <FaUsers />
            <span>Users</span>
          </Link>
          <Link to="/admin-product-images" className="admin-nav-item">
            <FaImage />
            <span>Images</span>
          </Link>
          <Link to="/admin-products" className="admin-nav-item">
            <FaShoppingBag />
            <span>Products</span>
          </Link>
          <Link to="/admin-offers" className="admin-nav-item">
            <FaGift />
            <span>Offers</span>
          </Link>
          <Link to="/admin-settings" className="admin-nav-item">
            <FaCog />
            <span>Settings</span>
          </Link>
        </nav>

        {/* Admin Profile */}
        <div className="admin-profile-container" ref={dropdownRef}>
          <button className="admin-profile-btn" onClick={toggleDropdown}>
            <FaUser />
            <span>Admin</span>
          </button>

          {showDropdown && (
            <div className="admin-dropdown">
              <div className="admin-dropdown-header">
                <div className="admin-dropdown-info">
                  <div className="admin-dropdown-name">Administrator</div>
                  <div className="admin-dropdown-email">admin@banat.com</div>
                </div>
              </div>

              <div className="admin-dropdown-links">
                <Link to="/admin-dashboard" className="admin-dropdown-link">
                  <FaChartBar />
                  Dashboard
                </Link>
                <Link to="/admin-settings" className="admin-dropdown-link">
                  <FaCog />
                  Settings
                </Link>
              </div>

              <div className="admin-dropdown-divider"></div>

              <button className="admin-logout-btn" onClick={handleLogout}>
                <FaSignOutAlt />
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader; 